import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Banner, EditBanner } from "../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../UI/Modal";
import BannerForm from "../BannerForm";

type Props = {
  banner?: Banner;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (data: EditBanner) => void;
};

const BannerModal: FC<Props> = ({
  banner,
  isOpen,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {banner
            ? t("components.screenBanners.bannerModal.typeEdit")
            : t("components.screenBanners.bannerModal.typeNew")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <BannerForm
          isSubmitting={isSubmitting}
          editable
          isAdmin
          onSubmit={(data: any) => onSubmit(data)}
          validable={false}
          onCancel={onClose}
          banner={banner}
        />
      </ModalBody>
    </Modal>
  );
};

export default BannerModal;
